// extracted by mini-css-extract-plugin
export default {"login-form-container":"style_login-form-container__IuDXc","page-header":"style_page-header__qEl+M","include-margin-top":"style_include-margin-top__H05ru"};